/** ສະແດງຄ່າຕົວເລກ KPI ຕາມຫົວໜ່ວຍ — ສະກຸນເງິນໃຊ້ຕົວຄັ່ນເລກ */
export type KpiTargetUnitForFormat =
  | "percent"
  | "count"
  | "score"
  | "currency"
  | "none"
  | null;

export function formatKpiValueByUnit(
  value: number | null | undefined,
  targetUnit: KpiTargetUnitForFormat,
): string {
  if (value == null) return "—";
  if (targetUnit === "currency") {
    return value.toLocaleString("th-TH", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
  return String(value);
}
